module.exports = __webpack_public_path__ + "images/stickers/pete-vacation@2x.060295310e437200bf33.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-vacation@2x.png
// module id = 6ISY
// module chunks = 24